import { Button, CloseButton, Form } from "react-bootstrap";
import update from "immutability-helper";
import _ from "lodash";

import StepWrapper from "./StepWrapper";
import AppComponent from "../../../../Components/AppComponent";
import { calculateTotalPaidRtoLoss } from "../../../../Modules/utils/calculations";

class RTOLossStep extends AppComponent {
  updateCod(cod) {
    const updatedData = {
      ...this.props.data,
      cod: {
        ...(this.props.data?.cod || {}),
        ...cod,
      },
    };

    this.props.onSubmit({
      ...updatedData,
    });
  }

  addRtoLoss() {
    this.props.onSubmit({
      rtoLossList: [
        ...(this.props.data.rtoLossList || []),
        { uid: Math.random(), amount: "", id: "", note: "" },
      ],
    });
  }

  // compute paid/unpaid totals from the list
  getRtoTotals(rtoLossList = []) {
    const total = rtoLossList.reduce((acc, item) => {
      const amt = parseFloat(item?.amount) || 0;
      acc += amt;
      return acc;
    }, 0);

    return { total };
  }

  render() {
    const { data, totalSteps, onSubmit } = this.props;

    const { rtoLossList = [] } = data;

    const totals = this.getRtoTotals(rtoLossList);

    return (
      <StepWrapper
        step={data.step}
        total={totalSteps}
        onPrev={() => onSubmit({ step: data.step - 1 })}
        onNext={() => onSubmit({ step: data.step + 1 })}
      >
        <Form.Group>
          <Form.Label>RTO Loss</Form.Label>

          {!rtoLossList.length ? (
            <center>
              <Button
                variant="outline-primary"
                type="button"
                onClick={this.addRtoLoss.bind(this)}
              >
                Add RTO Lost Item
              </Button>
            </center>
          ) : (
            rtoLossList.map((item, i) => {
              const setItem = (data) =>
                this.props.onSubmit({
                  rtoLossList: update(rtoLossList, {
                    $merge: { [i]: { ...item, ...data } },
                  }),
                });

              return (
                <div
                  className="d-flex align-items-center mb-2"
                  key={item._id || item.uid || item.id}
                >
                  <Form.Control
                    type="text"
                    placeholder="AWB Id"
                    value={item.id}
                    onChange={(e) => setItem({ id: e.target.value })}
                    required
                    className="me-2"
                  />
                  <Form.Control
                    type="number"
                    placeholder="Amount"
                    value={item.amount}
                    onChange={(e) => setItem({ amount: e.target.value })}
                    required
                    min={0}
                    step="0.01"
                    className="me-2"
                  />
                  <Form.Control
                    type="text"
                    placeholder="Note (optional)"
                    value={item.note}
                    onChange={(e) => setItem({ note: e.target.value })}
                    className="me-2"
                  />
                  <div className="p-2">
                    <CloseButton
                      onClick={() =>
                        this.props.onSubmit({
                          rtoLossList: update(rtoLossList, {
                            $splice: [[i, 1]],
                          }),
                        })
                      }
                    />
                  </div>
                </div>
              );
            })
          )}

          {rtoLossList.length ? (
            <center className="mt-3">
              <Button
                variant="outline-primary"
                size="sm"
                type="button"
                onClick={this.addRtoLoss.bind(this)}
              >
                Add More Item
              </Button>
            </center>
          ) : null}

          {/* Totals row */}
          <div className="d-flex justify-content-between align-items-center mt-3">
            <div>
              <small className="text-muted">Total RTO Loss</small>
              <div>
                <strong>{totals.total.toFixed(2)}</strong>
              </div>
            </div>
          </div>
        </Form.Group>
      </StepWrapper>
    );
  }
}

export default RTOLossStep;
